import { render, staticRenderFns } from "./FilterDatesSelector.component.vue?vue&type=template&id=24ef67fa&scoped=true"
import script from "./FilterDatesSelector.component.vue?vue&type=script&lang=ts"
export * from "./FilterDatesSelector.component.vue?vue&type=script&lang=ts"
import style0 from "./FilterDatesSelector.component.vue?vue&type=style&index=0&id=24ef67fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef67fa",
  null
  
)

export default component.exports